import {Controller} from "stimulus"

export default class extends Controller {
    static get targets() {
        return ["wrapper"]
    }

    connect() {
        this.wrapper = $(this.wrapperTarget)
        this.loadingSpinner = this.wrapper.find('.loading-spinner')

        this.startDate = this.wrapper.data('startDate')
        this.endDate = this.wrapper.data('endDate')
        this.previousDate = this.wrapper.data('previousDate')
        this.inRecommendationsTable = this.wrapper.data('inRecommendationsTable')
        this.inCallcenterManagerFrame = this.wrapper.data('inCallcenterManagerFrame')

        this.wrapper.on('reloadPointsTable', this._reload_points_table)
    }

    disconnect() {
        this.wrapper.unbind('reloadPointsTable');
    }

    _reload_points_table = () => {
        this.loadingSpinner.show()

        const params = new URLSearchParams({
            start_date: this.startDate,
            end_date: this.endDate,
            previous_date: this.previousDate,
            in_recommendations_table: this.inRecommendationsTable,
            in_callcenter_manager_frame: this.inCallcenterManagerFrame,
            campaign: this.wrapper.data('campaign')
        });

        Rails.ajax({
            url: `/points_tables/structure_points_tables?${params.toString()}`,
            type: 'get',
            success: (data) => {
                if (data.valid) {
                    this.wrapper.html(data.html)
                } else {
                    console.log(data.message)
                }
            }
        })
    }
}